<template>
  <button
    class="OnboardingQuizCard w-full p-4 rounded-xl border-2 transition-all duration-200 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
    :class="{
      'bg-white border-gray-200 hover:border-gray-300': !isSelected,
      'bg-primary/10 border-primary shadow-lg': isSelected
    }"
    @click="$emit('click')"
  >
    <div class="flex flex-col items-center text-center gap-2">
      <!-- Emoji -->
      <div class="text-3xl mb-1">
        {{ emoji }}
      </div>

      <!-- Title -->
      <div class="font-semibold text-gray-900 text-base leading-tight">
        {{ title }}
      </div>

      <!-- Subtitle (optional) -->
      <div v-if="subtitle" class="text-sm text-gray-600">
        {{ subtitle }}
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'OnboardingQuizCard',

  props: {
    isSelected: {
      type: Boolean,
      default: false
    },
    emoji: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.OnboardingQuizCard {
  min-height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
